import React, { useState } from "react";
import { Box, Button, Paper, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import { ArrowForward, InfoOutlined } from "@mui/icons-material";
import IconFamilyLaw from "@/src/assets/iconsRedesign2026/familyLaw/toggleable/IconFamilyLaw";
import IconTrafficLaw from "@/src/assets/iconsRedesign2026/traffic/toggleable/IconTrafficLaw";
import IconEmploymentLaw from "@/src/assets/iconsRedesign2026/common/toggleable/IconEmploymentLaw";
import IconContractLaw from "@/src/assets/iconsRedesign2026/contract/toggleable/IconContractLaw";
import IconRentalLaw from "@/src/assets/iconsRedesign2026/contract/toggleable/IconRentalLaw";
import IconCivilLaw from "@/src/assets/iconsRedesign2026/civilLaw/toggleable/IconCivilLaw";
import IconCivilServiceLaw from "@/src/assets/iconsRedesign2026/administrativeLaw/toggleable/IconCivilServiceLaw";
import AccordionGroupProvider from "@/src/components/Accordion/AccordionGroupProvider";
import Typography from "@mui/material/Typography";
import Accordion from "@/src/components/Accordion/Accordion";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";

const productCategories = [
  {
    headline: "Vertragsrecht",
    headlineIcon: IconContractLaw,
    products: [
      {
        label: "Beratung / Vertretung Vertragsrecht",
        description: "Wir prüfen Ihre Verträge und beraten Sie bei vertraglichen Auseinandersetzungen.",
      },
    ],
  },
  {
    headline: "Mietrecht",
    headlineIcon: IconRentalLaw,
    products: [
      {
        label: "Beratung / Vertretung Mietrecht",
        description: "Unterstützung bei allen Angelegenheiten rund um das Thema Mietrecht.",
      },
    ],
  },
  {
    headline: "Verkehrsrecht",
    headlineIcon: IconTrafficLaw,
    products: [
      {
        label: "Verkehrsunfall",
        description: "Rechtliche Unterstützung bei Personen- und Sachschäden nach einem Verkehrsunfall.",
        path: "/servicewelt/verkehrsrecht/verkehrsunfall",
      },
      {
        label: "Ordnungswidrigkeit",
        description: "Beratung und Vertretung rund um Bußgelder im Bereich Verkehr.",
        path: "/servicewelt/verkehrsrecht/ordnungswidrigkeit",
      },
    ],
  },
  {
    headline: "Familienrecht",
    headlineIcon: IconFamilyLaw,
    products: [
      {
        label: "Scheidung",
        description: "Wir begleiten Sie professionell und persönlich bei Ihrer Scheidung.",
        path: "/servicewelt/familienrecht/scheidung",
      },
      {
        label: "Erstberatung Unterhalt",
        description: "Ehegatten-, Kindesunterhalt oder andere Fragen rund um das Thema Unterhalt.",
      },
      {
        label: "Erstberatung Todesfall & Erbrecht",
        description: "Beratung bei allen Angelegenheiten rund um das Thema Erbrecht.",
      },
      {
        label: "Erstberatung Familienrecht",
        description: "Sie haben ein anderes familienrechtliches Anliegen? Wir sind für Sie da.",
      },
    ],
  },
  {
    headline: "Arbeitsrecht",
    headlineIcon: IconEmploymentLaw,
    products: [
      {
        label: "Beratung / Vertretung Arbeitsrecht",
        description: "Professionelle Begleitung bei Abmahnung, Arbeitszeugnissen oder ungeklärten Gehaltsfragen.",
      },
      {
        label: "Kündigungsschutzklage",
        description: "Wir prüfen Ihre Kündigung und übernehmen die weitere rechtliche Vertretung.",
        path: "/servicewelt/arbeitsrecht/kuendigung",
      },
    ],
  },
  {
    headline: "Allgemeines Zivilrecht",
    headlineIcon: IconCivilLaw,
    products: [
      {
        label: "Beratung / Vertretung Zivilrecht",
        description: "Begleitung bei allen Ihren zivilrechtlichen Angelegenheiten.",
      },
    ],
  },
  {
    headline: "Beamtenrecht",
    headlineIcon: IconCivilServiceLaw,
    products: [
      {
        label: "Beratung / Vertretung Beamtenrecht",
        description: "Wir prüfen Ihre dienstrechtliche Situation und vertreten Sie zuverlässig.",
      },
    ],
  },
];

const ServiceWorldNewCase = () => {
  const [legalExpenseInsuranceModalOpen, setLegalExpenseInsuranceModalOpen] = useState(false);

  return (
    <>
      <AccordionGroupProvider defaultActiveId={productCategories[0].headline}>
        <Stack spacing={2}>
          {productCategories.map((category) => (
            <Accordion key={category.headline} accordionId={category.headline} icon={category.headlineIcon} title={category.headline} variant={"contained"}>
              <Grid container spacing={2}>
                {category.products.map((product) => (
                  <Grid size={{ xs: 12, md: 6 }} key={product.label}>
                    <Paper sx={{ padding: "1.5rem", height: "100%" }}>
                      <Stack spacing={2} sx={{ height: "100%", justifyContent: "space-between" }}>
                        <Box>
                          <Typography component={"h3"} variant={"h7"}>
                            {product.label}
                          </Typography>
                          <Typography sx={{ marginTop: "0.5rem" }}>{product.description}</Typography>
                        </Box>

                        <Box>
                          {product.path ? (
                            <Button component={Link} to={product.path} variant={"contained"} endIcon={<ArrowForward />} size={"small"}>
                              Jetzt starten
                            </Button>
                          ) : (
                            <Button onClick={() => setLegalExpenseInsuranceModalOpen(true)} size={"small"}>
                              Mehr erfahren <InfoOutlined sx={{ marginLeft: "0.5rem" }} />
                            </Button>
                          )}
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Accordion>
          ))}
        </Stack>
      </AccordionGroupProvider>

      <DialogModal
        open={legalExpenseInsuranceModalOpen}
        onClose={() => setLegalExpenseInsuranceModalOpen(false)}
        title={"Prüfung Ihrer Rechtschutzversicherung erforderlich"}
      >
        Dieser Service kann erst genutzt werden, wenn bereits eine <strong>Deckungszusage Ihrer Rechtsschutzversicherung</strong> vorliegt. Aktuell unterstützen
        wir in diesem Rechtsbereich nur bestimmte Versicherungspartner. Schreiben Sie uns unter{" "}
        <LinkLegalbird to={"mailto:service@legalbird.de"}>service@legalbird.de</LinkLegalbird>, und wir klären, ob Ihre Versicherung dazu gehört!
      </DialogModal>
    </>
  );
};

export default ServiceWorldNewCase;
